import { User } from '@owc/connection-wko-manager';
import UserState from '../../../../models/store/modules/user-state.model';

const mutations = {
  token(state: UserState, payload: string): void {
    state.token = payload;
  },
  wkoUserData(state: UserState, payload: User): void {
    state.wkoUserData = payload;
  },
  b2xCoreProfile(state: UserState, payload: any): void {
    state.b2xCoreProfile = payload;
  },
};

export { mutations };
